<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="primary"
        class="mr-4"
        to="customers/add"
        rounded
      >
        Add Customer
      </v-btn>
      <v-btn icon text @click="getItems" v-if="refresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        clearable
        dense
        filled
        outlined
        rounded
      ></v-text-field>
      <v-btn icon color="primary" @click="exportCSV"><v-icon>download</v-icon></v-btn>
    </v-card-title>
    <v-data-table 
      :headers="headers"
      :items="list" 
      :loading="loading"
      :server-items-length="totalItems"
      :options.sync="options"
    >
      <template v-slot:item.action="{ item }">
        <v-btn icon text :to="`customers/view/${item.id}`" class="mr-1" v-if="viewButton">
          <v-icon small>visibility</v-icon>
        </v-btn>
        <v-btn icon text :to="`customers/edit/${item.id}`" class="mr-1" v-if="editButton">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn icon text @click="deleteItem(item)" color="red" v-if="deleteButton">
          <v-icon small>delete</v-icon>
        </v-btn>
        <v-btn text color="primary" outlined v-if="selectButton" @click="selectCell(item)">
          Select
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import api from "@/api";
import { download } from "../../directive/ExportToCSV";
// import { debounce } from "lodash";
export default {
  name: "AllCells",
  props: {
    refresh: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    viewButton: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    editButton: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    deleteButton: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    selectButton: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    selectCell: Function
  },
  data: () => ({
    totalItems: 0,
    dialog: false,
    loading: false,
    options: {},
    headers: [
      {
        text: 'Name',
        value: 'fullname',
      },
      { text: 'City', value: 'city' },
      { text: 'Phone', value: 'phone' },
      { text: 'Make', value: 'make' },
      { text: 'Year', value: 'year' },
      { text: 'Vin', value: 'vin' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    list: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: '',
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    search: ''
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    options: {
      handler () {
        this.getItems()
      },
      deep: true,
    },
    search() {
      this.getItems()
    }
  },
  methods: {
    initialize () {
      this.getItems()
    },

    async getItems() {
      const { page = 0, itemsPerPage = 10 } = this.options
      this.loading = true;
      const response = await api.searchCustomers(this.search, itemsPerPage, page);
      this.totalItems = response.data.count;
      this.list = response.data.data;
      this.loading = false;
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
    },

    async deleteItem (item) {
      const confirm = await this.$alert.confirm();
      if(confirm && confirm.value === true) {
        try {
          await api.deleteCustomer([item.id]);
          this.getItems()
          this.$toast.success({ title: "Deleted Successfully" })
        } catch (error) {
          this.$toast.error({ title: "Error Deleting" })
        }
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem)
      } else {
        this.desserts.push(this.editedItem)
      }
      this.close()
    },
    async exportCSV() {
      const response = await api.getCustomerCSV();
      download(response.data);
    }
  },
  mounted() {
    
  }
};
</script>